import React, { createContext } from "react";

export const DocumentContext = createContext();
